module.exports = __webpack_public_path__ + "static/media/shop.81fe43aa.svg";